import React, { useState } from 'react';
import DashboardLayout from "../layouts/DashboardLayout";
import { changeSecurityCode } from "../../api/AdminApi";

const DashboardPage = () => {
    const [securityCode, setSecurityCode] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSecurityCodeChange = async () => {
        if (!securityCode.trim()) {
            alert('보안코드를 입력해주세요.');
            return;
        }

        const codeNum = parseInt(securityCode);
        if (isNaN(codeNum) || codeNum < 0 || codeNum > 2000000000) {
            alert('보안코드는 0 이상 20억 이하의 숫자여야 합니다.');
            return;
        }

        try {
            setIsLoading(true);
            await changeSecurityCode(codeNum);
            alert('보안코드가 성공적으로 변경되었습니다.');
            setSecurityCode('');
        } catch (error) {
            console.error('보안코드 변경 실패:', error);
            alert('보안코드 변경에 실패했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <DashboardLayout>
            <div className="p-3">
                <h1 className="text-lg font-bold mb-3">대시보드</h1>
                
                <div className="bg-white border border-gray-200 p-4 mb-4">
                    <h2 className="text-lg font-medium text-gray-800 mb-2">환영합니다</h2>
                    <p className="text-gray-600">
                        좌측 메뉴를 통해 각 관리 기능에 접근할 수 있습니다.<br/>
                        장애 발생 시 010-2694-9736 으로 문의 주세요.
                    </p>
                </div>

                {/* 보안코드 변경 */}
                <div className="bg-white border border-gray-200 p-3">
                    <h3 className="text-sm font-bold text-gray-800 mb-2">어드민 보안코드 변경</h3>
                    <div className="flex items-center gap-2">
                        <input
                            type="number"
                            value={securityCode}
                            onChange={(e) => setSecurityCode(e.target.value)}
                            placeholder="새 보안코드 (0 ~ 20억)"
                            className="px-2 py-1 border border-gray-300 text-xs w-40"
                            min="0"
                            max="2000000000"
                            disabled={isLoading}
                        />
                        <button
                            onClick={handleSecurityCodeChange}
                            disabled={isLoading}
                            className="px-3 py-1 bg-blue-200 border border-gray-400 hover:bg-blue-300 disabled:bg-gray-200 disabled:cursor-not-allowed text-xs"
                        >
                            {isLoading ? '변경 중...' : '변경'}
                        </button>
                    </div>
                </div>
            </div>
        </DashboardLayout>
    );
};

export default DashboardPage;
